import React, { Fragment } from 'react'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import routes from '../router/routers'
import MainLayout from '../page/mainPage/mainPage'
import ProtectedRoute from '../router/ProtectedRoute'
import Auth from '../page/auth/auth'
import InventoryBarcode from '../page/other/inventoryBarcode'
import ListInventoryBarcode from '../page/other/listInventoryBarcode'
import InventoryBarcodeExport from '../page/other/inventoryBarcodeExport'
import ListInventoryBarcodeExport from '../page/other/listInventoryBarcodeExport'
import { useDispatch } from 'react-redux'
import ConstContextProvider from '../store/context/constContext'
import { useEffect } from 'react';
import { getAccessRoles } from '../store/reducers/permistion'

function Layout() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAccessRoles())
  },[])
  return (
    <ConstContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path='/login' element={<Auth />} />
          <Route path='/Im' element={<InventoryBarcode />} />
          <Route path='/ListIm' element={<ListInventoryBarcode />} />
          <Route path='/Ex' element={<InventoryBarcodeExport />} />
          <Route path='/ListEx' element={<ListInventoryBarcodeExport />} />
          {/* <Route path='/serviceStatus' element={<ServiceStatus />} /> */}
          <Route element={<ProtectedRoute />}>
            {routes.map((route, index) => {
              let LayoutPage = MainLayout
              if (route.layout) {
                LayoutPage = route.layout
              } else if (route.layout === null) {
                LayoutPage = Fragment
              }
              return (
                <Route key={index}
                  path={route.path}
                  element={
                    <LayoutPage>
                      <route.component {...route.props} />
                    </LayoutPage>
                  }>

                </Route>
              )
            })}
          </Route>
        </Routes>
      </BrowserRouter>
    </ConstContextProvider>

  )
}

export default Layout
